/** @format — tracking.summary AG-UI (detail cards only; map CTA lives on tracking.map) */

import React from "react";
import TrackingDetailCards from "./TrackingDetailCards";

export default function TrackingSummaryCard({ props = {} }) {
  return (
    <div className="flex flex-col gap-2 w-full max-w-[320px]">
      <TrackingDetailCards props={props} />
    </div>
  );
}
